import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "moment/locale/fr";
import {
  addCandidateSkills,
  deleteCandidateSkill,
  updateCandidateSkill,
} from "../../../redux/actions/admin/CandidateActions";
import "moment/locale/fr";
import { CircularProgress } from "@material-ui/core";
import localStorageService from "../../../services/localStorageService";

let SkillResume = (props) => {
  const {
    skillList,
    addCandidateSkills,
    deleteCandidateSkill,
    updateCandidateSkill,
  } = props;

  const closeDeleteSkillModal = React.useRef();
  const [
    displayingCandidateSkillList,
    setDisplayCandidateSkillList,
  ] = React.useState([]);
  const [showSkillForm, setShowSkillForm] = React.useState(false);
  const [showUpdateForm, setShowUpdateForm] = React.useState({});
  const [isSkillAdding, setIsSkillAdding] = React.useState(false);
  const [isSkillUpdating, setIsSkillUpdating] = React.useState(false);
  const [isSkillDeletting, setIsSkillDeletting] = React.useState(false);
  const [published, setPublished] = React.useState(false);
  const [skillTodelete, setSkillTodelete] = React.useState(null);
  const [candidate, setCandidate] = React.useState(null);
  const [newSkill, setNewSkill] = React.useState({
    id: "",
    title: "",
    percentage: "",
  });
  const [skillToUpdate, setSkillToUpdate] = React.useState({});

  useEffect(() => {
    if (skillList !== null && displayingCandidateSkillList.length === 0) {
      setDisplayCandidateSkillList(skillList);
    }
  }, [skillList]);

  const toggleForm = () => {
    setShowSkillForm(!showSkillForm);
  };

  const toggleUpdateForm = (skill) => {
    setSkillToUpdate(skill);
    setShowUpdateForm((prevState) => ({
      ...prevState,
      [skill.id]: !prevState[skill.id],
    }));
  };

  const handleCreateSkillSubmit = async () => {
    setIsSkillAdding(true);
    let skill = newSkill;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    skill.candidateId = candidate.id;
    try {
      const data = await addCandidateSkills(skill);
      if (data.success) {
        setDisplayCandidateSkillList(data.candidate.skills);
        setCandidate(data.candidate);
        clearSkillForm();
      }
      setIsSkillAdding(false);
      setPublished(true);
      setShowSkillForm(false);
    } catch (error) {
      setIsSkillAdding(false);
    }
  };
  const clearSkillForm = () => {
    setNewSkill({
      id: "",
      title: "",
      percentage: "",
    });
  };
  const handleUpdateSkillSubmit = () => {
    setIsSkillUpdating(true);
    let skill = skillToUpdate;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    skill.candidateId = candidate.id;

    updateCandidateSkill(skill).then((data) => {
      if (data.success) {
        setDisplayCandidateSkillList(data.candidate.skills);
        setCandidate(data.candidate);
      }
      setIsSkillUpdating(false);
      setPublished(false);
      toggleUpdateForm(skill);
    });
  };

  const handleDeleteSkillSubmit = () => {
    setIsSkillDeletting(true);
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    deleteCandidateSkill(candidate?.id, skillTodelete.id).then((resp) => {
      if (resp.success === true) {
        setDisplayCandidateSkillList(resp.candidate.skills);
        setCandidate(resp.candidate);
      }
      setSkillTodelete("");
      closeDeleteSkillModal.current.click();
      setIsSkillDeletting(false);
    });
  };

  return (
    <React.Fragment>
      <div className="bg-light-3 p-4">
        <div className="row">
          <div className="col-md-7 col-sm-5 d-flex align-items-center">
            <div className="section-title mb-0 ">
              <h3 className="title mb-0">
                {" "}
                <span>Compétences Professionnelle</span>
              </h3>
            </div>
          </div>
          <div
            className="col-md-5 col-sm-7 mt-3 mt-sm-0 pr-3"
            style={{ textAlign: "right" }}
          >
            <button className="btn btn-primary" onClick={toggleForm}>
              Ajouter une Compétence
            </button>
          </div>
        </div>
        <div className="row">
          {showSkillForm == true && (
            <div className="col-xl-12">
              <div className="mt-4">
                <div className="bg-light-3">
                  <div _lpchecked="1">
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <label>Titre </label>
                        <input
                          value={newSkill.title}
                          type="text"
                          className="form-control"
                          id="title"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewSkill((prevState) => {
                              return { ...prevState, title: val };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>Pourcentage </label>
                        <input
                          value={newSkill.percentage}
                          type="number"
                          className="form-control"
                          id="percentage"
                          min={0}
                          max={100}
                          onChange={(e) => {
                            let val = e.target?.value;
                            val = Math.min(Math.max(val, 0), 100);
                            setNewSkill((prevState) => {
                              return { ...prevState, percentage: val };
                            });
                          }}
                        />
                      </div>

                      <div className="col-12 mt-4">
                        <button
                          className="btn btn-primary"
                          onClick={handleCreateSkillSubmit}
                          disabled={isSkillAdding}
                          style={{ textAlign: "right", float: "right" }}
                        >
                          Ajouter &nbsp;{" "}
                          {isSkillAdding ? (
                            <CircularProgress size={15} />
                          ) : (
                            <span></span>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-xl-12 mt-4">
            {displayingCandidateSkillList?.length !== 0 && (
              <div className="timeline-box bg-white p-3 ">
                {displayingCandidateSkillList?.map((skill, index) => (
                  <div className="jobster-timeline-item" key={index}>
                    <div className="jobster-timeline-info">
                      <div className="dashboard-timeline-info">
                        <div className="row">
                          <div className="col-12">
                            <div className="row">
                              <div className="col-12">
                                <div className="row">
                                  <div className="col-10">
                                    <span className="text-dark">
                                      {skill.title}
                                    </span>

                                    <span className="jobster-timeline-time float-right">
                                      {skill.percentage}%
                                    </span>
                                    <div className="progress mt-2">
                                      <div
                                        className="progress-bar"
                                        role="progressbar"
                                        style={{
                                          width: `${skill.percentage}%`,
                                        }}
                                        aria-valuenow={skill.percentage}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                      ></div>
                                    </div>
                                  </div>
                                  <div className="col-2">
                                    <div className="dashboard-timeline-edit">
                                      <ul className="list-unstyled mb-0 d-flex justify-content-end">
                                        <li className="pr-2">
                                          <a
                                            href="javascript:void(0)"
                                            onClick={() =>
                                              toggleUpdateForm(skill)
                                            }
                                          >
                                            <i className="fas fa-pencil-alt"></i>
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            href="#"
                                            className="text-danger"
                                            data-toggle="modal"
                                            title=""
                                            data-target="#deleteSkill"
                                            data-original-title="Delete"
                                          >
                                            <i
                                              className="far fa-trash-alt text-danger"
                                              onClick={() =>
                                                setSkillTodelete(skill)
                                              }
                                            ></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {showUpdateForm[skill.id] && (
                              <div className="col-12">
                                <div className="my-4">
                                  <div className="bg-light-3 p-4">
                                    <div _lpchecked="1">
                                      <div className="form-row">
                                        <div className="form-group col-md-6">
                                          <label>Titre </label>
                                          <input
                                            value={skillToUpdate.title}
                                            type="text"
                                            className="form-control"
                                            id="title"
                                            onChange={(e) => {
                                              let val = e.target?.value;
                                              setSkillToUpdate((prevState) => {
                                                return {
                                                  ...prevState,
                                                  title: val,
                                                };
                                              });
                                            }}
                                          />
                                        </div>
                                        <div className="form-group col-md-6">
                                          <label>Pourcentage </label>
                                          <input
                                            value={skillToUpdate.percentage}
                                            type="number"
                                            className="form-control"
                                            id="percentage"
                                            min={0}
                                            max={100}
                                            onChange={(e) => {
                                              let val = e.target?.value;
                                              val = Math.min(
                                                Math.max(val, 0),
                                                100
                                              );
                                              setSkillToUpdate((prevState) => {
                                                return {
                                                  ...prevState,
                                                  percentage: val,
                                                };
                                              });
                                            }}
                                          />
                                        </div>

                                        <div className="col-12 mt-4">
                                          <button
                                            className="btn btn-primary"
                                            onClick={handleUpdateSkillSubmit}
                                            disabled={isSkillUpdating}
                                            style={{
                                              textAlign: "right",
                                              float: "right",
                                            }}
                                          >
                                            Mettre à jour &nbsp;{" "}
                                            {isSkillUpdating ? (
                                              <CircularProgress size={15} />
                                            ) : (
                                              <span></span>
                                            )}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Start Delete  modale */}
        <div
          className="modal fade"
          id="deleteSkill"
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
        >
          <div
            className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header p-4">
                <h4 className="mb-0 text-center">
                  Suppression d'une compétence
                </h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form className="mt-2">
                <div className="modal-body">
                  <div>
                    <div className="form-row">
                      <p>
                        Voulez vous supprimer cette compétence:{" "}
                        {skillTodelete?.title}?
                      </p>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    data-dismiss="modal"
                    className="btn btn-primary"
                    ref={closeDeleteSkillModal}
                  >
                    NON
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleDeleteSkillSubmit}
                    disabled={isSkillDeletting}
                  >
                    OUI &nbsp;{" "}
                    {isSkillDeletting ? (
                      <CircularProgress size={15} />
                    ) : (
                      <span></span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* End Delete  modale */}
      </div>
    </React.Fragment>
  );
};

SkillResume.propTypes = {
  addCandidateSkills: PropTypes.func.isRequired,
  deleteCandidateSkill: PropTypes.func.isRequired,
  updateCandidateSkill: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  addCandidateSkills: PropTypes.func.isRequired,
  deleteCandidateSkill: PropTypes.func.isRequired,
  updateCandidateSkill: PropTypes.func.isRequired,
});

export default connect(mapStateToProps, {
  addCandidateSkills,
  deleteCandidateSkill,
  updateCandidateSkill,
})(SkillResume);
